import { CampaignType, CampaignTypeFilter } from 'modules/domains/campaign';

export const UPSERT_CAMPAIGN_API_URL = '/campaigns/createSubmit';

export const CAMPAIGN_TYPE_SAVE_NAMES_MAPPER: Record<
  CampaignType | CampaignTypeFilter.Triggered,
  CampaignTypeFilter
> = {
  [CampaignType.ApiTriggered]: CampaignTypeFilter.Triggered,
  [CampaignType.Blast]: CampaignTypeFilter.Blast,
  [CampaignType.Eligibility]: CampaignTypeFilter.Eligibility,
  [CampaignType.WithAI]: CampaignTypeFilter.WithAI,
  [CampaignType.WithExperiment]: CampaignTypeFilter.WithExperiment,
  [CampaignType.WorkflowTriggered]: CampaignTypeFilter.FromWorkflow,

  /**
   * Note: Restful api type that doesn't require a CampaignType addition
   */
  Triggered: CampaignTypeFilter.Triggered,
};
